// @flow
import * as React from "react";
import Title from "./Title";
import type { Tab } from "../Tabs";

type TitlesProps = {
  tabs: Array<Tab>,
  activeIndex: number,
  changeActiveIndex: (index: number) => void
};

const Titles = ({ tabs, activeIndex, changeActiveIndex }: TitlesProps) =>
  tabs.map<React.Node>((tab, tabIndex) => (
    <Title
      // eslint-disable-next-line react/no-array-index-key
      key={tabIndex}
      tab={tab}
      tabIndex={tabIndex}
      activeIndex={activeIndex}
      changeActiveIndex={changeActiveIndex}
    />
  ));

Titles.defaultProps = {
  tabs: []
};

export default Titles;
